import { amtReg, goodQQEmailReg, billNameReg, billNameRegMsg, emailReg } from '../../../constants/regConstants'

/**
 * 待处理列表的验证，因之前导入已验过，此处简单验证，不常变更
 * 
 * 整表校验（遍历校验各行）
 * @param {Array} dataResource [record1,record2....]
 */
function getDataResourceWithValid(dataResource) {
    console.log('getDataResourceWithValid')
    return dataResource.map((record) => {
        return getRecordWithValid(record);
    });
}

/**
 * 整行校验并在record添加校验结果
 * @param {object } record 一行的数据：{开立票据名称:'方世玉',身份证号:'320...xx',...,Email:'xx@xx.xx'}
 */
function getRecordWithValid(record) {
    record.billNameValid = record['开立票据名称'] ? true : false;//必填
    record.idcValid = /^\w{0,18}$/.test(record['身份证号']);//不大于18位

    //邮箱去空格
    record['邮箱'] = record['邮箱'].replaceAll(/\s*/g, "");

    record.creditNoValid = true;//TODO 暂时不验证
    record.amtValid = amtReg.test(record['金额']);//'大于等于0.01，最多两位小数'

    //用途字段 必填
    record.purposeValid = /^(?!undefined)[\s\S]+$/.test(record['用途']);

    record.volunteerNoValid = record['志工编号'] ? true : false;//必填;
    record.volunteerNameValid = true;//不验证中文名了，直接true
    record.phoneValid = !record['手机号'] || /^1\d{10}$/.test(record['手机号']);
    //邮箱验证修改
    record.emailValid = !record['邮箱'] || /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(record['邮箱']);
    record.emailQQValid = goodQQEmailReg.test(record['邮箱']);
    record.rcdValid = record.billNameValid && record.idcValid && record.creditNoValid && record.amtValid && record.purposeValid && record.volunteerNoValid && record.volunteerNameValid && record.phoneValid && record.emailValid;
    record.outlandValid = true;
    record.legalValid = true;
    record.legalRequireValid = true;
    return record;
}

export { getDataResourceWithValid, getRecordWithValid }